import { InfiosIcon, InfiosSpinner } from '@infios/uikit/react';
import styles from './GateState.module.css';

interface GateStateProps {
  icon: string;
  title: string;
  body?: string;
  variant?: 'default' | 'error';
  spinning?: boolean;
}

/**
 * Full-panel placeholder for the non-chat states (waiting on host handshake,
 * fatal error, no permission). Fills the iframe and stays visually consistent
 * with the chat surface.
 */
export function GateState({ icon, title, body, variant = 'default', spinning }: GateStateProps) {
  return (
    <div className={styles.gate} role="status">
      <div className={`${styles.iconWrap} ${variant === 'error' ? styles.iconError : ''}`}>
        {spinning ? <InfiosSpinner /> : <InfiosIcon name={icon} />}
      </div>
      <h1 className={styles.title}>{title}</h1>
      {body ? <p className={styles.body}>{body}</p> : null}
    </div>
  );
}
